export const opticalRouteDef = [
    {
        path: ':id/:resource/processOrder',
        component: 'OpticaOrderComponent',
        data: {
            selector: 'app-optical-main'
        }
    },
    {
        path: ':id/:resource/vieworder',
        component: 'OpticalViewComponent',
        data: {
            selector: 'app-optical-view'
        }
    },
    {
        path: ':id/:resource/vieworder__optical',
        component: 'UiEngineComponent',
        data: {
            selector: 'app-ui-engine',
            resource:"opticalPOView",
            action:"LIST"
        }
    },
    {
        path: ':id/:resource/vieworder__optical_completedBills',
        component: 'UiEngineComponent',
        data: {
            selector: 'app-ui-engine',
            resource:"opticalPOView_completedBills",
            action:"LIST"
        }
    },
    {
        path: ':id/:resource/approvebilling',
        component:'OpticalApproveBillingComponent',
        data : {
            selector: 'app-optical-approve-billing'
        }
    },
    {
        path: 'opticalrefund',
        component:'OpticalrefundComponent',
        data : {
            selector: 'app-opticalrefund'
        }
    },
    {
        path: ':id/:resource/viewglasshistory',
        component: 'OpticalViewComponent',
        data: {
            selector: 'app-optical-view'
        }
    },
    {
        path: 'settleDue',
        component:'UiEngineComponent',
        data : {
            selector: 'app-ui-engine',
            resource: 'due_settlement',
            action: 'ADD',
        }
    },
    {
        path: ':scm_grnMaster_optical',
        component: 'UiEngineComponent',
        data: {
            selector: 'app-ui-engine',
            resource: 'scm_grnMaster_optical',
            action: 'MODIFY',
        }
    }
]
